export const SIDENAV_TYPES = {
  UPDATE_SIDENAV_DATA: "UPDATE_SIDENAV_DATA",
};

const initialState = {
  id: "infotext-modal",
  title: "",
  isOpen: false,
  setIsOpen: () => {},
  content: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SIDENAV_TYPES.UPDATE_SIDENAV_DATA:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
